<template>
  <div class="live">
        <div class="header">
          <img src="https://summit-img.geekpark.net/ifx/live/live-header.png" alt="">
        </div>
    <div class="sm-header">
      <img src="https://summit-img.geekpark.net/IFX-10th%20logo.svg" alt="">
      <img src="https://summit-img.geekpark.net/ifx/live/live-location.png" style="position: absolute; right: 1.5%; bottom: 26%; width: 37%;">
    </div>
    <section>
      <a href="http://vphotos.cn/7Gel">现场图片直播</a>
      <a href="http://vphotos.cn/7Geg">前沿社冬季会晤 <span>（会员密码进入）</span></a>
      <a href="http://vphotos.cn/7GeW">现场花絮图片直播</a>
<!--      <a href="">亮点</a>-->
    </section>
    <div class="footer">
      <a href="https://www.geekpark.net/">
        <img src="//summit-img.geekpark.net/if2019/img/logo.56158ae2.png" alt="">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Live'
}
</script>

<style scoped lang="less">
  .live {
    font-family: Noto Sans S Chinese, NotoSansHans, Open Sans, Hiragino Sans GB, Lantinghei SC, Microsoft YaHei, STHeiti, WenQuanYi Micro Hei, PingFang SC, Helvetica Neue, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    .header {
      display: block;;
      height: 30vh;

      img {
        height: 100%;
        max-width: 100%;
      }
    }

    .sm-header {
      display: none;
    }

    section {
      a {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 18vh;
        color: #fff;
        text-decoration: none;
        font-size: 32px;
        font-weight: 400;

        &:first-of-type {
          background-color: rgb(235, 78, 38);
        }

        &:nth-of-type(2) {
          background-color: rgb(26, 26, 26);

          span {
            font-size: .5em;
            font-weight: 300;
          }
        }

        &:nth-of-type(3) {
          background-color: rgb(196, 196, 196);
        }
      }
    }

    .footer {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 18vh;
      background: #292929;

      img {
        height: 4vh;
        vertical-align: middle;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .live {
      .header {
        display: none;
      }

      .sm-header {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 28vh;
        background: url("https://summit-img.geekpark.net/mobile/%E8%83%8C%E6%99%AF-%E7%BA%BF.svg") 0 0 ~ "/" 100% auto no-repeat,
                    url("https://summit-img.geekpark.net/nav-ifx.svg") 20% 0 ~ "/" contain no-repeat;
        img{
          width: 98%;
          background: #fff;
        }
      }

      section {
        a {
          font-size: 5.5vw;
        }
      }
    }
  }
</style>
